<template>
  <div
    class="new-content"
    key="showButton"
    @click="closeMessage"
    @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
    @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
  >
    <p v-html="message" />
  </div>
</template>

<script>
export default {
  name: 'NewContentButton',
  data() {
    return {
      showButton: true,
      timeout: null,
    };
  },
  computed: {
    message() {
      const { message } = this.$store.state.message[this.$route.params.city];

      return message === '' ? 'Look! A page has been updated!' : message;
    },
  },
  methods: {
    closeMessage() {
      this.$store.state.message[this.$route.params.city].toDisplay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.new-content {
  position: fixed;
  bottom: 30px;
  right: 40px;
  padding: 20px 28px;

  font-size: 16px;
  background-color: $color-white;
  color: rgba($color-black, 0.55);
  border-radius: 5px;

  z-index: z-index(header);

  button {
    border: 0;
    color: $color-black;
    background-color: transparent;
    cursor: pointer;

    &:focus {
      outline: transparent;
    }
  }
}
</style>
